import { render, staticRenderFns } from "./otherwork.vue?vue&type=template&id=c5be58d4&scoped=true"
import script from "./otherwork.vue?vue&type=script&lang=js"
export * from "./otherwork.vue?vue&type=script&lang=js"
import style0 from "./otherwork.vue?vue&type=style&index=0&id=c5be58d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5be58d4",
  null
  
)

export default component.exports